import Chart from 'chart.js';

window.Chart = Chart;

export default Chart;
